import i18next from "i18next";
import { reactI18nextModule } from "react-i18next";

import translationEN from "./locales/en/translation.json";
import translationFR from "./locales/fr/translation.json";

export const RESOURCES = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
};

export const DEFAULT_LANG = "fr";

const detectLanguageFromUrl = {
  // tslint:disable-next-line: no-empty
  cacheUserLanguage(): void {},
  detect(): string {
    if (
      window.location.pathname.startsWith("/en/") ||
      window.location.pathname === "/en"
    ) {
      return "en";
    }

    return "fr";
  },
  // tslint:disable-next-line: no-empty
  init: (): void => {},
  type: "languageDetector",
};

i18next
  .use(reactI18nextModule)
  .use(detectLanguageFromUrl)
  .init({
    fallbackLng: DEFAULT_LANG,
    interpolation: {
      escapeValue: false,
    },
    resources: RESOURCES,
  });

export const i18n = i18next;

export default i18next;
